import React, { useEffect, useState } from 'react';
import { Button, ConfigProvider, Input, Space, Typography } from 'antd';
import { Modal } from 'react-bootstrap';
import { WhatsAppOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import { useWabaMessageList } from './store';

const { Text } = Typography;

const TestWaba = ({ submitValidation, waba, setSendTo, sendTo }) => {
    const { sendWaba } = useWabaMessageList()
    const [formData, setFormData] = useState({ key: '', template_id: '', type: '', button_url: '', cta: false, dynamic: false, static: false, body: '' });
    const [paramCount, setParamCount] = useState(0);
    const [show, setShow] = useState(false);
    const [params, setParams] = useState({});
    const [mediaUrl, setMediaUrl] = useState('');
    const [ctaUrl, setCtaUrl] = useState();
    const [isFormValid, setIsFormValid] = useState(false);

    const countParams = (messageBody, substring) => {
        const escapedSubstring = substring.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(escapedSubstring, 'g');
        const matches = messageBody.match(regex);
        return matches ? matches.length : 0;
    }

    useEffect(() => {
        if (waba) {
            setFormData({
                key: get(waba, 'key', ''),
                template_id: get(waba, 'template_id', ''),
                type: get(waba, 'type', ''),
                button_url: get(waba, 'button_url', ''),
                static: get(waba, 'static', false),
                dynamic: get(waba, 'dynamic', false),
                cta: get(waba, 'cta', false),
                body: get(waba, 'body', '')
            });
            const count = countParams(waba.body, '{}');
            setParamCount(count);
            setParams(Object.fromEntries(Array(count).fill().map((_, i) => [i, ''])));
        }
    }, [waba]);

    useEffect(() => {
        validateForm();
    }, [params, mediaUrl, ctaUrl, formData, sendTo]);

    const validateForm = () => {
        const isMediaUrlValid = formData.type.toLowerCase() === 'video' || formData.type.toLowerCase() === 'image' ? !!mediaUrl : true;
        const areParamsValid = Object.values(params).every(param => !!param);
        const isCtaUrlValid = formData.cta ? !!ctaUrl : true;
        const isSendToValid = !!sendTo;

        setIsFormValid(isMediaUrlValid && areParamsValid && isCtaUrlValid && isSendToValid);
    };

    const onParamsChange = (event) => {
        const { name, value } = event.target;
        setParams(prevParams => ({...prevParams, [name]: value }));
    };

    const generateParamsInput = (n) => {
        return Array.from({ length: n }, (_, index) => (
            <Space.Compact key={index} block className='my-3'>
                <span
                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-content-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Param {index + 1}</Text>
                </span>
                <Input
                    style={{ width: '70%' }}
                    allowClear
                    placeholder={`Enter Param ${index+1}`}
                    name={index.toString()}
                    onChange={onParamsChange}
                    value={params[index]}
                />
            </Space.Compact>
        ));
    }

    return (
        <>
            <ConfigProvider theme={{token: { colorPrimary: '#00b96b'}}}>
                <Button className='flex-1' type="primary" onClick={() => setShow(true)}>
                    Test Waba
                </Button>
            </ConfigProvider>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Test WABA</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {['video', 'image'].includes((formData.type).toLowerCase()) && (
                            <Space.Compact block className='my-3'>
                                <span
                                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-content-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>Media URL</Text>
                                </span>
                                <Input
                                    style={{ width: '70%' }}
                                    allowClear
                                    placeholder='Media URL'
                                    onChange={event => setMediaUrl(event.target.value)}
                                    value={mediaUrl}
                                />
                            </Space.Compact>
                        )}
                        {generateParamsInput(paramCount)}
                        {formData.cta && (
                            <Space.Compact block className='my-3'>
                                <span
                                    style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-content-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>CTA URL</Text>
                                </span>
                                <Input
                                    style={{ width: '70%' }}
                                    allowClear
                                    placeholder='CTA URL'
                                    onChange={event => setCtaUrl(event.target.value)}
                                    value={ctaUrl}
                                />
                            </Space.Compact>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex justify-content-between w-100 gap-2'>
                        <Button variant="secondary" className='flex-1' onClick={() => setShow(false)}>
                            Close
                        </Button>
                        <div className='flex-fill'>
                            <ConfigProvider theme={{token: { colorPrimary: '#00b96b'}}}>
                                <Space.Compact block>
                                    <Input 
                                        onChange={(event) => setSendTo(event.target.value)} 
                                        placeholder='Phone' 
                                        value={sendTo}
                                    />
                                    <Button 
                                        type="primary" 
                                        disabled={!isFormValid || submitValidation('send')}
                                        onClick={() => {
                                            const _params = [];
                                            if(mediaUrl){ _params.push(mediaUrl); }
                                            for(let i = 0; i < paramCount; i++){ _params.push(params[i]); }
                                            if(ctaUrl){ _params.push(ctaUrl); }
                                            const data = { phone_number: '+91' + sendTo, key: formData.key, params:_params }
                                            sendWaba(data);
                                        }}
                                    >
                                        <WhatsAppOutlined />
                                    </Button>
                                </Space.Compact>
                            </ConfigProvider>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default TestWaba;